/* chat-followup-input.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./chat-followup-input.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Fragment, useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import Form, { Field } from '@atlaskit/form';
import SendIcon from '@atlaskit/icon/core/send';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { usePublish } from '@atlaskit/rovo-triggers';
import TextField from '@atlaskit/textfield';
import { useAIAnswerContext } from '../../../ai-answer-dialog/ai-answer-context';
import { onOpenChatButtonClick } from '../../../ai-answer-dialog/analytics';
import { SainAction, useAnalytics, useSAINUsageCriteriaMet } from '../../controller/analytics';
import { ErrorBoundary } from '../error-boundary';
import { messages } from './messages';
var containerStyles = xcss({
  borderRadius: '3px',
  border: "1px solid ".concat("var(--ds-border, #091E4224)"),
  padding: 'space.100'
});
var inputFieldContainerStyles = xcss({
  flex: 1
});
var textFieldStyles = null;
export var ChatFollowupInput = function ChatFollowupInput(_ref) {
  var answerString = _ref.answerString,
    query = _ref.query,
    source = _ref.source,
    experimentCohort = _ref.experimentCohort;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var publish = usePublish('ai-mate');
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var sendToChat = useCallback(function (formData) {
    if (!Boolean(formData.followupQuery)) {
      return;
    }
    fireAnalyticsEvent(onOpenChatButtonClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
      experimentCohort: experimentCohort
    })));
    fireSAINUsageEvent({
      metCriteria: SainAction.OPEN_CHAT_CLICKED
    });
    publish({
      type: 'chat-new',
      source: source,
      data: {
        name: query.substring(0, 30),
        dialogues: [{
          human_message: {
            content: query
          },
          agent_message: {
            content: answerString
          }
        }],
        prompt: formData.followupQuery,
        sourceId: commonAttributes.searchSessionId
      }
    });
    formData.followupQuery = '';
  }, [query, answerString, publish, commonAttributes, fireAnalyticsEvent, fireSAINUsageEvent, source, experimentCohort]);
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: /*#__PURE__*/React.createElement(Fragment, null)
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: containerStyles
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: sendToChat
  }, function (_ref2) {
    var formProps = _ref2.formProps;
    return /*#__PURE__*/React.createElement("form", formProps, /*#__PURE__*/React.createElement(Inline, {
      grow: "fill",
      spread: "space-between",
      alignBlock: "center",
      space: "space.100"
    }, /*#__PURE__*/React.createElement(Box, {
      xcss: inputFieldContainerStyles
    }, /*#__PURE__*/React.createElement(Field, {
      name: "followupQuery"
    }, function (_ref3) {
      var fieldProps = _ref3.fieldProps;
      return /*#__PURE__*/React.createElement(TextField, _extends({
        autoComplete: "off",
        placeholder: formatMessage(messages.ai_answer_component_ai_answer_ask_more_chat)
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        ,

        appearance: "none",
        testId: "ai-answer-chat-followup-input"
      }, fieldProps, {
        className: ax(["_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _1pfhx0bf _12qbidpf _1f5xidpf _15eiidpf _1pxmidpf"])
      }));
    })), /*#__PURE__*/React.createElement(IconButton, {
      icon: SendIcon,
      label: formatMessage(messages.ai_answer_component_ai_answer_ask_more_chat_submit),
      type: "submit",
      testId: "ai-answer-chat-followup-input-submit",
      spacing: "compact"
    })));
  })));
};